import React, { useRef } from "react";
import { Box, Card, CardBody, CardFooter, CardHeader, Image, Text } from "grommet";
import { MapViewModel } from "./MapsStore";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import ParallaxTilt from "../components/ParallaxTilt";
import ParallaxTilt2 from "../components/ParallaxTilt2";
import { normalizeColor } from "grommet/utils";
import Theme from "../utils/Theme";
import { useDarkMode } from "../components/DarkModeSwitch";
import Avatar from "react-avatar";

export const MapCard: React.FC<{ map: MapViewModel; width?: number }> = ({ map, width }) => {
    const [isDarkMode] = useDarkMode();
    const background = normalizeColor("background", Theme, isDarkMode);
    return (
            <ParallaxTilt2 style={{ backgroundImage: "url(" + map.splashUri + ")", backgroundColor: background }}>
                <Card width={!!width ? width + "px" : "250px"} height={!!width ? width * 1.5 + "px" : "375px"}>
                    <CardBody align="center" justify="center" background={`url(${map.logoUri})`}>
                        <Box align="center">{!map.logoUri && <Avatar style={{ objectFit: "contain" }} name={map.name} round="10px" />}</Box>
                    </CardBody>
                    {/* <CardHeader pad="small" justify="center" fill="horizontal"></CardHeader> */}
                    <CardFooter pad="small" background="background-front">
                        <Box direction="row" gap="small" justify="between" fill="horizontal">
                            <Text textAlign="center">{map.name}</Text>
                            <Text textAlign="center">
                                <FontAwesomeIcon icon={["fad", "download"]}></FontAwesomeIcon> {map.downloads}
                            </Text>
                        </Box>
                    </CardFooter>
                </Card>
            </ParallaxTilt2>
    );
};
